// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
  width: min(100%, 400px);
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./frontend/page/page-login.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".login {\n  width: min(100%, 400px);\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
